// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-up-right.js';

import { paths } from '../generated/arrow-up-right';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-up-right', Original, paths);
